/* global axios */
import ApiClient from './ApiClient';

class StandardRolePermissionsAPI extends ApiClient {
  constructor() {
    super('standard_role_permissions', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(role, permissions) {
    return axios.patch(this.url, { role, permissions });
  }
}

export default new StandardRolePermissionsAPI();
